import { InjectionToken } from '@angular/core';
import { DukanShopRepository } from 'src/app/core/repositories/dukan-shop.repository';

export const dukanShopRepositoryToken: InjectionToken<DukanShopRepository> =
  new InjectionToken<DukanShopRepository>('Dukan Shop Injection Token');
